export const COLORS = {
	PRIMARY: "#0948b3",
	SECONDARY: "#262b40",
	YANKEES_BLUE: "#1F2937",
	CULTURED: "#F5F8FB",
	GHOST_WHITE: "#F9F9F9",
	INDEPENDENCE: "#4A5073",
	BRIGHT_GRAY: "#EDEEF1",
	CRAYOLA: "#323a46",
	ZERO_CRAYOLA: "#0948B3",
	EERIE_BLACK: "#191919",
	RAJAH: "#F5B759",
	INTERNATIONAL_ORANGE: "#C74634",
	ARSENIC: "#383C4D",
	METALIC_SILVER: "#A8AAB3",
	SPANISH_GRAY: "#9395A0",
	UCLA_BLUE: "#506690",
	SLATE_GRAY: "#66799E",
	DEEP_CHESNUT: "#B95243",
	HOOKERS_GREEN: "#47745E",
	WHITE: "#000000",
};
